var _defs, _rect, _path, _g, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _rect26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignupExampleCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 816.87 488.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.k,.l,.m{fill:none;}.b{fill:#dddfe4;}.c{fill:#435e70;}.d{clip-path:url(#a);}.e{fill:#bdc9cc;}.f{fill:#062333;}.g{fill:#fff;}.h{fill:#294455;}.i{fill:#627684;}.j{fill:#f2f2f2;}.k,.l,.m{stroke:#062333;stroke-miterlimit:10;stroke-width:4px;}.l{stroke-dasharray:5.57 5.57;}.m{stroke-dasharray:5.71 5.71;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 357.87,
    y: 36.35,
    width: 351,
    height: 272.02
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 79.99,
    y: 32.5,
    width: 695.88,
    height: 279.88
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M771.87,36.5V308.38H84V36.5H771.87m8-8H76V316.38H779.87V28.5Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M717.87,166.82A167.88,167.88,0,1,1,550-1.07,167.85,167.85,0,0,1,717.87,166.82ZM532,263.54a25.48,25.48,0,0,1-7.5-18V220a25.43,25.43,0,0,0-13.16-22.33c-11.49-6.28-27.74-15.22-38.91-20.8a116.1,116.1,0,0,1-25.2-17.37l-.63-.57a89.27,89.27,0,0,1-14.43-16.49c-7.5-10.94-19.69-29-27.59-40.74a159,159,0,0,0-14,65.13c0,88,71.52,159.46,159.46,159.46V304.43C551.35,294.39,543.93,275.57,532,263.54Zm176-76.32-23.29-5.8a19.34,19.34,0,0,1-11.23-8l-14.36-21.53a19,19,0,0,1,0-21.23l15.63-23.42a19.75,19.75,0,0,1,7.33-6.48l10.37-5.18C666.23,43.39,612.34,7.36,550,7.36c-2.07,0-4.06.25-6.06.32L566.5,30.23a12.83,12.83,0,0,1,0,18L562.75,52l-8.21,8.22a6.36,6.36,0,0,0,0,9L558.29,73a6.4,6.4,0,0,1,0,9l-6.38,6.38a6.47,6.47,0,0,1-4.55,1.84h-7.17A6.3,6.3,0,0,0,535.71,92l-7.88,7.68a6.29,6.29,0,0,0-1.29,7.4L539,132a6.41,6.41,0,0,1-5.74,9.24h-4.46a6.35,6.35,0,0,1-4.15-1.59l-7.41-6.46a12.67,12.67,0,0,0-12.36-2.49L480,139a9.51,9.51,0,0,0-1.28,17.54l8.85,4.38a53.84,53.84,0,0,0,24.16,5.76c8.37,0,18,21.75,25.51,25.51h53.35a25.41,25.41,0,0,1,18,7.48l10.93,10.93a24.38,24.38,0,0,1,7.08,17.22,36.91,36.91,0,0,1-10.91,26.31l-9,9a19.14,19.14,0,0,0-4.93,8.52c-1.2,4.54-2.24,9.1-3.84,13.48L584,322.54A159.79,159.79,0,0,0,708,187.22ZM486.84,20.44,506,30a12.78,12.78,0,0,0,18.5-11.41v-9A160.14,160.14,0,0,0,486.84,20.44Z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 541.46,
    y: 77.96,
    width: 271.87,
    height: 188.96,
    transform: "translate(849.83 -504.96) rotate(90)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 35.44,
    y: 336.07,
    width: 293.17,
    height: 44.12,
    rx: 4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 253.7,
    y: 65.38,
    width: 293.17,
    height: 44.12,
    rx: 8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 381.26,
    y: 336.07,
    width: 293.17,
    height: 44.12,
    rx: 4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 103.3,
    y: 149.06,
    width: 347.29,
    height: 4.82
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 103.3,
    y: 178.52,
    width: 410.63,
    height: 4.82
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 605.87,
    y: 251.76,
    width: 157.56,
    height: 2.41
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 605.87,
    y: 281.24,
    width: 157.56,
    height: 6.32
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 103.3,
    y: 231.72,
    width: 12.99,
    height: 2.44
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 120.41,
    y: 231.72,
    width: 12.99,
    height: 2.44
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 137.53,
    y: 231.72,
    width: 12.99,
    height: 2.44
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 154.65,
    y: 231.72,
    width: 12.99,
    height: 2.44
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 171.77,
    y: 231.72,
    width: 12.99,
    height: 2.44
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 188.88,
    y: 231.72,
    width: 12.99,
    height: 2.44
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 206,
    y: 231.72,
    width: 12.99,
    height: 2.44
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 223.12,
    y: 231.72,
    width: 12.99,
    height: 2.44
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 240.24,
    y: 231.72,
    width: 12.99,
    height: 2.44
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 257.35,
    y: 231.72,
    width: 12.99,
    height: 2.44
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 274.47,
    y: 231.72,
    width: 12.99,
    height: 2.44
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 291.59,
    y: 231.72,
    width: 12.99,
    height: 2.44
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 308.71,
    y: 231.72,
    width: 12.99,
    height: 2.44
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 325.82,
    y: 231.72,
    width: 12.99,
    height: 2.44
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 342.94,
    y: 231.72,
    width: 12.99,
    height: 2.44
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 123.9,
    y: 272.23,
    width: 100.98,
    height: 15.33,
    rx: 1
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 258.12,
    y: 272.23,
    width: 100.98,
    height: 15.33,
    rx: 2
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 392.34,
    y: 272.23,
    width: 100.98,
    height: 15.33,
    rx: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M703.68,236.23a14.84,14.84,0,0,0-3.5-1.95.12.12,0,0,1,0-.23q31.9-7.37,63.15-17.26a.14.14,0,0,0,.09-.12v-2.89a.12.12,0,0,0-.16-.11q-30.72,9.77-62.15,17.08a.12.12,0,0,1-.14-.18c1.09-2.09,2.18-4.17,3.26-6.26.56-1.07-.37-2.7-1.69-2.21-11.89,4.4-22.61,10-32.23,18.26-1.73-1.5-4.18-.66-3.25-1.72l18.71-29.89c.77-1.23-.81-2.94-2.06-2.06a30.64,30.64,0,0,1-21.19,5.4c-3.87-.38-8-.84-11.43,1.33-2.76,1.74-4.66,5-3.7,8.29.55,1.85,3.44,1.06,2.9-.8-.82-2.78,1.89-5.11,4.31-5.8,3.56-1,7.52.1,11.14.2a31.88,31.88,0,0,0,13.89-2.83.12.12,0,0,1,.15.18l-16.28,26a.14.14,0,0,1-.13.06l-11.71-2.29c-4.7-.91-11.37-3.15-15.56.34-4.8,4-1.4,10.72,1.07,15a55.07,55.07,0,0,0,11.05,13.5,1.52,1.52,0,0,0,2.36-.3l14.28-22.82a.12.12,0,0,1,.13-.06l3.63.71,2.6.5c1,.2,1.62-.53,2.34-1.12a95.27,95.27,0,0,1,7.66-5.77,101.53,101.53,0,0,1,18.22-9.87.12.12,0,0,1,.16.17q-1.27,2.47-2.57,4.93a.1.1,0,0,1-.08.07l-3.84.87a1.51,1.51,0,0,0,0,2.89l.3,0c-2.09,5.57-1,2.3-3.52,8.19L680,245h0a3.39,3.39,0,0,0-1.63.22,1.55,1.55,0,0,0-1.1,1.45,1.5,1.5,0,0,0,1.5,1.5l.89-.12h0c1,.17,1.42,2.1,1.58,2.95a12.32,12.32,0,0,1-.09,3.21c-.12,1.32-.31,2.62-.53,3.91a50.35,50.35,0,0,1-5.29,15.25c-.89,1.71,1.68,3.22,2.59,1.51l14.87-28.53a.13.13,0,0,1,.09-.07l5.7-.76,3.46-.46a10.61,10.61,0,0,0,2.89-.59,3.48,3.48,0,0,0,1.87-4.1C706.45,238.68,705,237.24,703.68,236.23Zm-54.61,25.52a.14.14,0,0,1-.2,0,53.75,53.75,0,0,1-10-13.14c-1.31-2.41-2.81-5.37-1.87-8.16.82-2.43,4-2.59,6.12-2.47a69.86,69.86,0,0,1,9.49,1.68l9,1.75a.12.12,0,0,1,.08.18Zm34.47-13.43a7.12,7.12,0,0,0-.35-.74l5.73-.76a.13.13,0,0,1,.13.18q-2.65,5.07-5.29,10.15c0-.19.06-.37.08-.56C684.22,253.83,684.64,251,683.54,248.32Zm20.13-6.56a7.15,7.15,0,0,1-2.53.42l-6.43.86a.12.12,0,0,1-.13-.18l3.2-6.14a.13.13,0,0,1,.15-.06,15.74,15.74,0,0,1,2.92,1.27,7.2,7.2,0,0,1,2.85,2.73C703.89,241,704.05,241.52,703.67,241.76Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M179.44,117.32v2a2,2,0,0,1-2,2h-68a2,2,0,0,1-2-2v-2a2,2,0,0,1,2-2h2v-8a4.31,4.31,0,0,1,4.57-4h3.43v-22h6v22h8v-22h6v22h8v-22h6v22h8v-22h6v22h3.43a4.32,4.32,0,0,1,4.57,4v8h2A2,2,0,0,1,179.44,117.32Zm-68-42V70.7a2,2,0,0,1,1.29-1.87L142,57.57a4.07,4.07,0,0,1,2.81,0l29.3,11.26a2,2,0,0,1,1.3,1.87v4.62a2,2,0,0,1-2,2h-60A2,2,0,0,1,111.44,75.32Zm58,34h-52v6h52ZM123,71.32h40.89l-20.44-7.86Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M712.27,146c-2.92,11.83-14.16,19.7-26.34,19.7h-.61v11.88a4,4,0,0,1-4,4h-7.92a4,4,0,0,1-4-4V165.69h-.7a34.62,34.62,0,0,1-21.35-7.27,4,4,0,0,1-.38-6l5.67-5.66a3.93,3.93,0,0,1,5.07-.43,19.11,19.11,0,0,0,11,3.49h18.27a10.15,10.15,0,0,0,10-11.73,10.54,10.54,0,0,0-7.7-8.29l-28.78-8.21a26,26,0,0,1-18.06-31.26c2.92-11.83,14.15-19.7,26.33-19.7h.62V58.78a4,4,0,0,1,4-4h7.92a4,4,0,0,1,4,4V70.66H686a34.72,34.72,0,0,1,21.36,7.28,4,4,0,0,1,.37,6l-5.67,5.67A3.94,3.94,0,0,1,697,90a19.18,19.18,0,0,0-11-3.49H667.74a10.16,10.16,0,0,0-10,11.73,10.53,10.53,0,0,0,7.7,8.29l28.78,8.22A26,26,0,0,1,712.27,146Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M71.56,358.76H67v9.11H62.85v-23.7h8.34A9.69,9.69,0,0,1,77.52,346a6.51,6.51,0,0,1,2.23,5.32,6.69,6.69,0,0,1-1.15,4,7.28,7.28,0,0,1-3.2,2.47l5.32,9.87v.21H76.31ZM67,355.44H71.2a4.71,4.71,0,0,0,3.26-1.05,3.67,3.67,0,0,0,1.17-2.88,3.9,3.9,0,0,0-1.08-2.94,4.58,4.58,0,0,0-3.23-1.07H67Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M82.53,358.9a10.42,10.42,0,0,1,1-4.66,7.57,7.57,0,0,1,2.88-3.19,8.16,8.16,0,0,1,4.27-1.11,7.68,7.68,0,0,1,5.78,2.29,9,9,0,0,1,2.4,6.09l0,.92a10.46,10.46,0,0,1-1,4.66A7.36,7.36,0,0,1,95,367.07a8.13,8.13,0,0,1-4.3,1.12,7.61,7.61,0,0,1-6-2.48,9.46,9.46,0,0,1-2.24-6.61Zm4,.34a7.09,7.09,0,0,0,1.13,4.26,3.92,3.92,0,0,0,6.24,0A7.9,7.9,0,0,0,95,358.9a7,7,0,0,0-1.15-4.23,3.87,3.87,0,0,0-6.19,0A7.67,7.67,0,0,0,86.48,359.24Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M112.91,366.14a6.12,6.12,0,0,1-5,2.05,5.44,5.44,0,0,1-4.33-1.67,7.11,7.11,0,0,1-1.48-4.85V350.26h4v11.36c0,2.24.93,3.35,2.78,3.35s3.22-.69,3.89-2.06V350.26h4v17.61H113Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M125.72,346v4.28h3.11v2.93h-3.11V363a2.16,2.16,0,0,0,.4,1.46,1.87,1.87,0,0,0,1.42.44,5.91,5.91,0,0,0,1.38-.16v3.06a9.71,9.71,0,0,1-2.6.37q-4.56,0-4.56-5v-10h-2.89v-2.93h2.89V346Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M131.85,345.69a2.15,2.15,0,0,1,.58-1.52,2.58,2.58,0,0,1,3.31,0,2.11,2.11,0,0,1,.59,1.52,2,2,0,0,1-.59,1.49,2.62,2.62,0,0,1-3.31,0A2.08,2.08,0,0,1,131.85,345.69Zm4.2,22.18h-4V350.26h4Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M144,350.26l.12,2a6.31,6.31,0,0,1,5.13-2.36c3.66,0,5.53,2.1,5.59,6.29v11.64h-4V356.46a3.59,3.59,0,0,0-.73-2.48,3,3,0,0,0-2.36-.81,3.82,3.82,0,0,0-3.57,2.17v12.53H140.3V350.26Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M158.2,358.94a10.3,10.3,0,0,1,1.93-6.56,6.18,6.18,0,0,1,5.12-2.44A5.8,5.8,0,0,1,170,352l.18-1.78h3.56v17.07a7.12,7.12,0,0,1-2.15,5.47,8.24,8.24,0,0,1-5.82,2A9.47,9.47,0,0,1,162,374a6.69,6.69,0,0,1-2.81-2.11l1.87-2.38a5.64,5.64,0,0,0,4.49,2.17,4.38,4.38,0,0,0,3.11-1.07,4.07,4.07,0,0,0,1.14-3.13v-1.19a5.82,5.82,0,0,1-4.56,1.9,6.16,6.16,0,0,1-5.05-2.45A10.62,10.62,0,0,1,158.2,358.94Zm3.94.34a7.09,7.09,0,0,0,1.08,4.17,3.46,3.46,0,0,0,3,1.52,3.8,3.8,0,0,0,3.55-2.05v-7.74a3.75,3.75,0,0,0-3.52-2,3.49,3.49,0,0,0-3,1.55A8,8,0,0,0,162.14,359.28Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M205.26,367.87h-4.12l-10.56-16.81v16.81h-4.11v-23.7h4.11l10.6,16.88V344.17h4.08Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M220.41,366.14a6.12,6.12,0,0,1-4.95,2.05,5.45,5.45,0,0,1-4.33-1.67,7.16,7.16,0,0,1-1.47-4.85V350.26h4v11.36c0,2.24.93,3.35,2.78,3.35s3.22-.69,3.89-2.06V350.26h4v17.61h-3.73Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M232,350.26l.12,1.84a6.33,6.33,0,0,1,5.07-2.16q3.54,0,4.84,2.7a6.24,6.24,0,0,1,5.4-2.7,5.48,5.48,0,0,1,4.34,1.61,7.07,7.07,0,0,1,1.45,4.75v11.57h-3.95V356.41a3.53,3.53,0,0,0-.73-2.45,3.18,3.18,0,0,0-2.43-.79,3.3,3.3,0,0,0-2.2.73,3.81,3.81,0,0,0-1.2,1.89l0,12.08h-4V356.28a2.82,2.82,0,0,0-3.17-3.11,3.48,3.48,0,0,0-3.37,1.94v12.76h-4V350.26Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M272.71,359.24a10.59,10.59,0,0,1-1.83,6.53,6,6,0,0,1-5,2.42A5.74,5.74,0,0,1,261,366l-.2,1.91h-3.58v-25h4V352a5.73,5.73,0,0,1,4.6-2,6,6,0,0,1,5.07,2.39,10.77,10.77,0,0,1,1.83,6.69Zm-3.95-.34a7.46,7.46,0,0,0-1-4.29,3.35,3.35,0,0,0-2.93-1.44,3.67,3.67,0,0,0-3.61,2.25v7.26a3.7,3.7,0,0,0,3.64,2.29,3.34,3.34,0,0,0,2.87-1.38,7.25,7.25,0,0,0,1-4.18Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M283.78,368.19a8.14,8.14,0,0,1-6.09-2.36,8.58,8.58,0,0,1-2.34-6.31V359a10.58,10.58,0,0,1,1-4.71,7.8,7.8,0,0,1,2.85-3.23,7.57,7.57,0,0,1,4.1-1.15,6.91,6.91,0,0,1,5.56,2.29,9.68,9.68,0,0,1,2,6.49v1.6h-11.5a5.31,5.31,0,0,0,1.45,3.45A4.43,4.43,0,0,0,284,365a5.34,5.34,0,0,0,4.42-2.2l2.14,2a7.09,7.09,0,0,1-2.83,2.45A8.83,8.83,0,0,1,283.78,368.19Zm-.47-15.08a3.33,3.33,0,0,0-2.63,1.14,5.94,5.94,0,0,0-1.28,3.17h7.54v-.29a4.8,4.8,0,0,0-1.06-3A3.31,3.31,0,0,0,283.31,353.11Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M303.13,353.87a10.6,10.6,0,0,0-1.61-.13,3.63,3.63,0,0,0-3.66,2.09v12h-4V350.26h3.78l.09,2a4.46,4.46,0,0,1,4-2.29,3.68,3.68,0,0,1,1.39.22Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M437.92,360.16a8.54,8.54,0,0,1-2.8,5.91,9.5,9.5,0,0,1-6.49,2.12,9.2,9.2,0,0,1-5-1.34,8.79,8.79,0,0,1-3.32-3.81,13.63,13.63,0,0,1-1.22-5.75v-2.21a13.89,13.89,0,0,1,1.18-5.91,9.08,9.08,0,0,1,3.41-3.94,9.53,9.53,0,0,1,5.14-1.38,9.17,9.17,0,0,1,6.31,2.12,8.86,8.86,0,0,1,2.78,6h-4.1a5.8,5.8,0,0,0-1.49-3.69,4.91,4.91,0,0,0-3.5-1.13,4.81,4.81,0,0,0-4.13,2,9.81,9.81,0,0,0-1.47,5.76V357a10.5,10.5,0,0,0,1.37,5.87,4.58,4.58,0,0,0,4,2,5.33,5.33,0,0,0,3.65-1.09,5.63,5.63,0,0,0,1.54-3.62Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M445.12,352.18a6.16,6.16,0,0,1,4.89-2.24q5.64,0,5.72,6.42v11.51h-4V356.51a3.48,3.48,0,0,0-.79-2.58,3.24,3.24,0,0,0-2.32-.76,3.81,3.81,0,0,0-3.54,2.12v12.58h-4v-25h4Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M467.48,368.19a8.18,8.18,0,0,1-6.1-2.36,8.58,8.58,0,0,1-2.33-6.31V359a10.71,10.71,0,0,1,1-4.71,7.75,7.75,0,0,1,2.86-3.23,7.55,7.55,0,0,1,4.1-1.15,6.91,6.91,0,0,1,5.56,2.29,9.73,9.73,0,0,1,2,6.49v1.6H463a5.32,5.32,0,0,0,1.46,3.45A4.39,4.39,0,0,0,467.7,365a5.34,5.34,0,0,0,4.43-2.2l2.13,2a7,7,0,0,1-2.82,2.45A8.86,8.86,0,0,1,467.48,368.19ZM467,353.11a3.31,3.31,0,0,0-2.62,1.14,5.86,5.86,0,0,0-1.28,3.17h7.53v-.29a4.8,4.8,0,0,0-1.05-3A3.32,3.32,0,0,0,467,353.11Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M484.84,365a3.56,3.56,0,0,0,2.46-.87,3,3,0,0,0,1-2.13h3.72a5.77,5.77,0,0,1-1,3.07,6.71,6.71,0,0,1-2.6,2.25,7.7,7.7,0,0,1-3.55.83A7.49,7.49,0,0,1,479,365.8a9.47,9.47,0,0,1-2.16-6.6v-.41a9.34,9.34,0,0,1,2.14-6.44,7.46,7.46,0,0,1,5.86-2.41,7.23,7.23,0,0,1,5.12,1.83,6.52,6.52,0,0,1,2.07,4.81h-3.72a3.63,3.63,0,0,0-1-2.49,3.27,3.27,0,0,0-2.46-1,3.46,3.46,0,0,0-3,1.39,7.06,7.06,0,0,0-1.06,4.22v.64a7.21,7.21,0,0,0,1,4.27A3.49,3.49,0,0,0,484.84,365Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M500.77,360.32l-1.76,1.8v5.75h-3.95v-25H499v14.42l1.24-1.54,4.87-5.49h4.75l-6.54,7.34,7.24,10.27H506Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M539.92,367.87h-4.11l-10.56-16.81v16.81h-4.12v-23.7h4.12l10.59,16.88V344.17h4.08Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M555.08,366.14a6.14,6.14,0,0,1-5,2.05,5.46,5.46,0,0,1-4.34-1.67,7.16,7.16,0,0,1-1.47-4.85V350.26h3.95v11.36c0,2.24.93,3.35,2.79,3.35s3.21-.69,3.88-2.06V350.26h4v17.61h-3.73Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M566.65,350.26l.11,1.84a6.35,6.35,0,0,1,5.08-2.16q3.52,0,4.83,2.7a6.24,6.24,0,0,1,5.4-2.7,5.48,5.48,0,0,1,4.34,1.61,7.13,7.13,0,0,1,1.46,4.75v11.57h-4V356.41a3.48,3.48,0,0,0-.73-2.45,3.18,3.18,0,0,0-2.43-.79,3.3,3.3,0,0,0-2.2.73,3.81,3.81,0,0,0-1.2,1.89l0,12.08h-4V356.28a2.82,2.82,0,0,0-3.17-3.11,3.49,3.49,0,0,0-3.37,1.94v12.76h-4V350.26Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M607.38,359.24a10.59,10.59,0,0,1-1.83,6.53,6,6,0,0,1-5,2.42,5.74,5.74,0,0,1-4.82-2.23l-.19,1.91h-3.58v-25h4V352a5.75,5.75,0,0,1,4.61-2,6,6,0,0,1,5.06,2.39,10.77,10.77,0,0,1,1.84,6.69Zm-4-.34a7.38,7.38,0,0,0-1-4.29,3.35,3.35,0,0,0-2.93-1.44,3.68,3.68,0,0,0-3.61,2.25v7.26a3.71,3.71,0,0,0,3.65,2.29,3.34,3.34,0,0,0,2.86-1.38,7.25,7.25,0,0,0,1-4.18Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M618.44,368.19a8.17,8.17,0,0,1-6.09-2.36,8.58,8.58,0,0,1-2.34-6.31V359a10.58,10.58,0,0,1,1-4.71,7.75,7.75,0,0,1,2.86-3.23,7.53,7.53,0,0,1,4.1-1.15,6.88,6.88,0,0,1,5.55,2.29,9.68,9.68,0,0,1,2,6.49v1.6H614a5.32,5.32,0,0,0,1.46,3.45,4.39,4.39,0,0,0,3.21,1.27,5.35,5.35,0,0,0,4.43-2.2l2.13,2a7.13,7.13,0,0,1-2.82,2.45A8.87,8.87,0,0,1,618.44,368.19ZM618,353.11a3.34,3.34,0,0,0-2.63,1.14,5.93,5.93,0,0,0-1.27,3.17h7.53v-.29a4.8,4.8,0,0,0-1.06-3A3.29,3.29,0,0,0,618,353.11Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M637.79,353.87a10.6,10.6,0,0,0-1.61-.13,3.63,3.63,0,0,0-3.66,2.09v12h-3.95V350.26h3.77l.1,2a4.45,4.45,0,0,1,4-2.29,3.77,3.77,0,0,1,1.4.22Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 170.44,
    y1: 291.07,
    x2: 170.44,
    y2: 294.07
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "l",
    x1: 170.44,
    y1: 299.64,
    x2: 170.44,
    y2: 330.28
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 170.44,
    y1: 333.07,
    x2: 170.44,
    y2: 336.07
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 476.44,
    y1: 291.07,
    x2: 476.44,
    y2: 294.07
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "l",
    x1: 476.44,
    y1: 299.64,
    x2: 476.44,
    y2: 330.28
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 476.44,
    y1: 333.07,
    x2: 476.44,
    y2: 336.07
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 341.44,
    y1: 291.07,
    x2: 341.44,
    y2: 294.07
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "m",
    x1: 341.44,
    y1: 299.78,
    x2: 341.44,
    y2: 411.21
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 341.44,
    y1: 414.07,
    x2: 341.44,
    y2: 417.07
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 205.15,
    y: 417.07,
    width: 293.17,
    height: 44.12,
    rx: 4
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M241.39,443.35h-9.17l-1.92,5.52H226l8.95-23.7h3.69l9,23.7h-4.3Zm-8-3.32h6.87l-3.43-9.83Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M257.16,446a3.56,3.56,0,0,0,2.46-.87,2.92,2.92,0,0,0,1-2.13h3.73a5.78,5.78,0,0,1-1,3.07,6.64,6.64,0,0,1-2.6,2.25,7.7,7.7,0,0,1-3.55.83,7.51,7.51,0,0,1-5.86-2.39,9.47,9.47,0,0,1-2.16-6.6v-.41a9.35,9.35,0,0,1,2.15-6.44,7.43,7.43,0,0,1,5.86-2.41,7.21,7.21,0,0,1,5.11,1.83,6.57,6.57,0,0,1,2.08,4.81h-3.73a3.62,3.62,0,0,0-1-2.49,3.31,3.31,0,0,0-2.47-1,3.48,3.48,0,0,0-3,1.39,7.14,7.14,0,0,0-1.06,4.22v.64a7.2,7.2,0,0,0,1,4.27A3.47,3.47,0,0,0,257.16,446Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M274.61,446a3.57,3.57,0,0,0,2.46-.87,3,3,0,0,0,1-2.13h3.72a5.77,5.77,0,0,1-1,3.07,6.67,6.67,0,0,1-2.61,2.25,7.63,7.63,0,0,1-3.54.83,7.48,7.48,0,0,1-5.86-2.39,9.48,9.48,0,0,1-2.17-6.6v-.41a9.35,9.35,0,0,1,2.15-6.44,7.44,7.44,0,0,1,5.86-2.41,7.25,7.25,0,0,1,5.12,1.83,6.52,6.52,0,0,1,2.07,4.81h-3.72a3.63,3.63,0,0,0-1-2.49,3.27,3.27,0,0,0-2.46-1,3.46,3.46,0,0,0-3,1.39,7.06,7.06,0,0,0-1.06,4.22v.64a7.21,7.21,0,0,0,1,4.27A3.49,3.49,0,0,0,274.61,446Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M284.08,439.9a10.42,10.42,0,0,1,1-4.66,7.53,7.53,0,0,1,2.89-3.19,8.1,8.1,0,0,1,4.26-1.11,7.68,7.68,0,0,1,5.78,2.29,9,9,0,0,1,2.4,6.09l0,.92a10.46,10.46,0,0,1-1,4.66,7.4,7.4,0,0,1-2.86,3.17,8.19,8.19,0,0,1-4.31,1.12,7.61,7.61,0,0,1-6-2.48,9.5,9.5,0,0,1-2.24-6.61Zm3.95.34a7.09,7.09,0,0,0,1.13,4.26,3.92,3.92,0,0,0,6.24,0,7.9,7.9,0,0,0,1.11-4.58,7,7,0,0,0-1.14-4.23,3.68,3.68,0,0,0-3.12-1.56,3.63,3.63,0,0,0-3.08,1.54A7.67,7.67,0,0,0,288,440.24Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M314.46,447.14a6.12,6.12,0,0,1-4.95,2.05,5.45,5.45,0,0,1-4.33-1.67,7.16,7.16,0,0,1-1.47-4.85V431.26h4v11.36c0,2.24.93,3.35,2.78,3.35s3.22-.69,3.89-2.06V431.26h4v17.61h-3.73Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M326,431.26l.12,2a6.3,6.3,0,0,1,5.12-2.36q5.5,0,5.6,6.29v11.64h-3.95V437.46a3.59,3.59,0,0,0-.73-2.48,3,3,0,0,0-2.36-.81,3.82,3.82,0,0,0-3.57,2.17v12.53h-3.95V431.26Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M345.8,427v4.28h3.11v2.93H345.8V444a2.22,2.22,0,0,0,.4,1.46,1.89,1.89,0,0,0,1.43.44,6,6,0,0,0,1.38-.16v3.06a9.71,9.71,0,0,1-2.6.37q-4.56,0-4.56-5v-10H339v-2.93h2.9V427Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M379.41,448.87h-4.12l-10.56-16.81v16.81h-4.12v-23.7h4.12l10.59,16.88V425.17h4.09Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M394.56,447.14a6.12,6.12,0,0,1-4.95,2.05,5.44,5.44,0,0,1-4.33-1.67,7.11,7.11,0,0,1-1.48-4.85V431.26h4v11.36c0,2.24.92,3.35,2.78,3.35s3.22-.69,3.89-2.06V431.26h3.95v17.61h-3.72Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M406.13,431.26l.11,1.84a6.35,6.35,0,0,1,5.08-2.16c2.35,0,4,.9,4.83,2.7a6.25,6.25,0,0,1,5.41-2.7,5.46,5.46,0,0,1,4.33,1.61,7.08,7.08,0,0,1,1.46,4.75v11.57h-4V437.41a3.48,3.48,0,0,0-.74-2.45,3.16,3.16,0,0,0-2.42-.79,3.33,3.33,0,0,0-2.21.73,3.73,3.73,0,0,0-1.19,1.89v12.08h-4V437.28c-.06-2.07-1.11-3.11-3.17-3.11a3.48,3.48,0,0,0-3.37,1.94v12.76h-4V431.26Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M446.86,440.24a10.59,10.59,0,0,1-1.83,6.53,6,6,0,0,1-5,2.42,5.72,5.72,0,0,1-4.81-2.23l-.2,1.91H431.4v-25h4V433a5.73,5.73,0,0,1,4.6-2,6,6,0,0,1,5.06,2.39,10.71,10.71,0,0,1,1.84,6.69Zm-3.95-.34a7.46,7.46,0,0,0-1-4.29,3.36,3.36,0,0,0-2.93-1.44,3.66,3.66,0,0,0-3.61,2.25v7.26A3.7,3.7,0,0,0,439,446a3.35,3.35,0,0,0,2.87-1.38,7.25,7.25,0,0,0,1-4.18Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M457.93,449.19a8.18,8.18,0,0,1-6.1-2.36,8.62,8.62,0,0,1-2.33-6.31V440a10.71,10.71,0,0,1,1-4.71,7.75,7.75,0,0,1,2.86-3.23,7.55,7.55,0,0,1,4.1-1.15,6.91,6.91,0,0,1,5.56,2.29,9.68,9.68,0,0,1,2,6.49v1.6H453.48a5.32,5.32,0,0,0,1.46,3.45,4.39,4.39,0,0,0,3.21,1.27,5.34,5.34,0,0,0,4.43-2.2l2.13,2a7,7,0,0,1-2.82,2.45A8.86,8.86,0,0,1,457.93,449.19Zm-.47-15.08a3.32,3.32,0,0,0-2.63,1.14,5.86,5.86,0,0,0-1.28,3.17h7.53v-.29a4.8,4.8,0,0,0-1.05-3A3.31,3.31,0,0,0,457.46,434.11Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M477.28,434.87a10.63,10.63,0,0,0-1.62-.13,3.63,3.63,0,0,0-3.66,2.09v12h-3.95V431.26h3.77l.1,2a4.46,4.46,0,0,1,4-2.29,3.74,3.74,0,0,1,1.4.22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupExampleCheck);
export default __webpack_public_path__ + "static/media/signup_exampleCheck.7a4283ac5a6a02076a7845b684af4476.svg";
export { ForwardRef as ReactComponent };